import { mapEntityProperties } from '@/utils/mapEntityProperties'
import type { DriverRankingMetricBreakdownAdminDto } from '@/backend/market'
import { DriverRankingMetricBreakdownEntity } from '../../domain/entities/DriverRankingMetricBreakdownEntity'

export class DriverRankingMetricBreakdownModel extends DriverRankingMetricBreakdownEntity {
  constructor(data: DriverRankingMetricBreakdownAdminDto) {
    super()
    mapEntityProperties(this, data)
  }
}
